export default __webpack_public_path__ + "static/media/HDTX_Announcement_of_GMS_2022.5e8fbd21.pdf";